import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Cell, DefaultEditor, Editor } from 'angular2-smart-table';

@Component({
  selector: 'ubs-smart-table-date-picker',
  template: `<input
  nbInput
  placeholder="Pick Date"
  [nbDatepicker]="dateTimePicker11"
/>
<nb-date-timepicker withSeconds #dateTimePicker11 size="small"> </nb-date-timepicker>`,
  styleUrls: ['./smart-table-date-picker.component.scss']
})
export class SmartTableDatePickerComponent  extends DefaultEditor implements AfterViewInit {

  constructor() { 
    super()
  }

  ngAfterViewInit() {

  }
  //`<input [ngClass]="inputClass" type="date" class="form-control" [(ngModel)]="cell.newValue" [name]="cell.getId()" [disabled]="!cell.isEditable()" (click)="onClick.emit($event)" (keydown.enter)="onEdited.emit($event)" (keydown.esc)="onStopEditing.emit()">`

  /* <input
  nbInput
  placeholder="Pick Date"
  [nbDatepicker]="dateTimePicker11"
/>
<nb-date-timepicker withSeconds #dateTimePicker11> </nb-date-timepicker> */

}
